import React from "react";
import { Grid, Typography, Paper, Button, Radio } from "@mui/material";

const ChoiceQuestion = ({ questionData, userId }) => {
  const [question, setQuestion] = React.useState(questionData);
  const [choice, setChoice] = React.useState(null);
  const [changed, setChanged] = React.useState(false);

  React.useEffect(() => {
    setChoice(questionData?.answer?.value);
  }, [questionData]);

  const handleUpdate = (answer) => {
   setChoice(answer);
   setChanged(true);
  };

  return (
    <Grid item xs={12}>
      <Paper elevation={1} style={{ padding: 10 }}>
        <Grid container spacing={0} justifyContent="center">
          <Grid item xs={12}>
            <Typography>{question?.question}</Typography>
          </Grid>
          {question?.choice1 ? (
            <Grid
              item
              xs={10}
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "space-between",
                cursor: "pointer",
              }}
              onClick={() => handleUpdate(question?.choice1)}
            >
              <Typography variant="body1">{question?.choice1}</Typography>
              <Radio checked={choice === question?.choice1 ? true : false} />
            </Grid>
          ) : (
            <></>
          )}
          {question?.choice2 ? (
            <Grid
              item
              xs={10}
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "space-between",
              }}
              onClick={() => handleUpdate(question?.choice2)}
            >
              <Typography variant="body">{question?.choice2}</Typography>
              <Radio checked={choice === question?.choice2 ? true : false} />
            </Grid>
          ) : (
            <></>
          )}
          {question?.choice3 ? (
            <Grid
              item
              xs={10}
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "space-between",
              }}
              onClick={() => handleUpdate(question?.choice3)}
            >
              <Typography variant="body1">{question?.choice3}</Typography>
              <Radio checked={choice === question?.choice3 ? true : false} />
            </Grid>
          ) : (
            <></>
          )}
          {question?.choice4 ? (
            <Grid
              item
              xs={10}
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "space-between",
              }}
              onClick={() => handleUpdate(question?.choice4)}
            >
              <Typography variant="body1">{question?.choice4}</Typography>
              <Radio checked={choice === question?.choice4 ? true : false} />
            </Grid>
          ) : (
            <></>
          )}
          {question?.choice5 ? (
            <Grid
              item
              xs={10}
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "space-between",
              }}
              onClick={() => handleUpdate(question?.choice5)}
            >
              <Typography variant="body1">{question?.choice5}</Typography>
              <Radio checked={choice === question?.choice5 ? true : false} />
            </Grid>
          ) : (
            <></>
          )}
         
        </Grid>
        {!changed ? (
            <></>
          ) : (
            <Grid item xs={12} >
              <Button
                variant="contained"
                style={{  marginTop: 15, marginBottom: 15 }}
                onClick={() => handleUpdate("clear")}
              >
                save{" "}
              </Button>
            </Grid>
          )}
      </Paper>
    </Grid>
  );
};

export default ChoiceQuestion;
